module.exports = __webpack_public_path__ + "static/media/contact-page-image.b7776e44.png";